export const wbsCodeIntegers = [];
export const wbsCodeFloats = [];
export const wbsCodeIsoStrings = [];
export const wbsCodeWhiteList = ['id', 'prefix', 'code', 'name', 'parentId'];
export const wbsCodeOptimisticList = [...wbsCodeWhiteList, 'parent', 'children'];
